import { TRootState }                                   from 'Redux/Reducers';
import { filterObjectStore, queryFilter, IFilterProps } from 'Utils';
import { OrganisationInvoice }                                      from 'Domain/Models';

export const getOrganisationInvoices = (state: TRootState, filter: null | IFilterProps<OrganisationInvoice> = null) => {
  if (filter === null) {
    filter = queryFilter({ sorting: { by: 'invoiceDate', order: 'ASC' } }) as IFilterProps<OrganisationInvoice>;
  }

  return filterObjectStore(state.organisationInvoice.entries, filter);
};
